const EUROS = new Intl.NumberFormat('es-ES', {
  style: 'currency',
  currency: 'EUR',
  minimumFractionDigits: 2,
})

const FECHA = new Intl.DateTimeFormat('es-ES', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
})

const ISO = /^(\d{4})-(\d{2})-(\d{2})/

/** `32` -> `32,00 €`. El negocio razona en euros con coma. */
export function formatearEuros(valor: number): string {
  return EUROS.format(valor)
}

/**
 * `2026-08-18` -> `18/08/2026`. Construida por partes y no con `new Date(iso)`:
 * una fecha sin hora la interpreta el navegador como medianoche **UTC**, y al
 * oeste de Greenwich saldria el dia anterior. En esta pantalla ese dia es el
 * del reparto, asi que equivocarlo por uno es equivocar el albaran.
 */
export function formatearFecha(iso: string): string {
  const partes = ISO.exec(iso)
  if (!partes) return iso
  return FECHA.format(new Date(Number(partes[1]), Number(partes[2]) - 1, Number(partes[3])))
}

/** Como se resolvio la ficha, en cristiano. El backend lo publica como texto. */
const MOTIVOS: Record<string, string> = {
  resuelto_por_nif: 'NIF unico',
  resuelto_por_nombre: 'Por nombre',
  resuelto_por_antiguedad: 'Ficha mas antigua',
  ambiguo: 'Hay que elegir',
  sin_ficha: 'Sin ficha en Odoo',
  sin_nif: 'Sin NIF',
  sin_cliente: 'No es cliente',
  sin_pedidos: 'Sin pedidos anteriores',
}

export function etiquetaMotivo(motivo: string): string {
  return MOTIVOS[motivo] ?? motivo
}

/** Como termino cada cliente al publicar. */
const ESTADOS: Record<string, string> = {
  publicado: 'Publicado',
  publicado_sin_evento: 'Publicado, falta el evento',
  duplicado: 'Ya existia',
  ambiguo: 'Sin ficha elegida',
  fallido: 'Fallido',
}

export function etiquetaEstado(estado: string): string {
  return ESTADOS[estado] ?? estado
}

/**
 * El rotulo del boton de publicar. Dice **cuantos clientes** y **que dia**,
 * porque lo que hay detras no se deshace: crea presupuestos que entran en el
 * ciclo de reparto de las 06:00. Un boton que solo pusiera "Publicar" obligaria
 * a mirar dos sitios mas antes de pulsarlo.
 */
export function rotuloPublicar(clientes: number, fecha: string): string {
  return `Publicar ${cuantosClientes(clientes)}${cuandoSea(fecha)}`
}

/**
 * El rotulo del boton que lleva de la tabla a la revision. Dice lo mismo que el
 * de publicar -cuantos marcados y que dia- porque es el mismo dato leido en el
 * mismo sitio: quien marca treinta casillas necesita ver el recuento sin apartar
 * la vista del boton que va a pulsar.
 */
export function rotuloRevisar(clientes: number, fecha: string): string {
  return `Revisar ${cuantosClientes(clientes)}${cuandoSea(fecha)}`
}

function cuantosClientes(clientes: number): string {
  return clientes === 1 ? '1 cliente' : `${clientes} clientes`
}

function cuandoSea(fecha: string): string {
  return fecha ? ` el ${formatearFecha(fecha)}` : ''
}
